<template>
  <div>
    <div class="Index">
      <div class="title">行业领域</div>
      <div class="content">
        <div class="options">
          <van-radio-group
            class="radioAll"
            v-model="radioValue"
            @change="radioChange"
          >
            <van-radio name="1" checked-color="#4967B7">
              工程建设领域拖欠工资线索反映
            </van-radio>
            <van-radio name="2" checked-color="#4967B7">
              非工程建设领域拖欠工资线索反映
            </van-radio>
          </van-radio-group>
        </div>
        <div class="tips">
          填写说明:
          请根据反映问题所属领域选择相应通道反映有关线索，带“*”的为必填项，其他为选填项。非同一单位欠薪，请分别填写线索。
        </div>
        <div class="agree">
          <van-checkbox
            checked-color="#4967B7"
            v-model="checked"
            shape="square"
          >
            同意使用须知:
            本平台旨在接收拖欠工资问题线索，在您反映情况时请如实填写相关信息，对您反映的问题线索我们将督促有关地方依法依规及时处理。
          </van-checkbox>
          <div class="btn">
            <van-button
              :disabled="!checked"
              color="#4967B7"
              class="submitBtn"
              type="info"
              @click="toEngineer"
              >下一步</van-button
            >
          </div>
        </div>
      </div>
      <van-dialog
        v-model="show"
        title="提示"
        confirmButtonText="关闭"
        class="yantai-dialog"
        :show-confirm-button="false"
        :show-cancel-button="false"
      >
        【通知：自2024年2月8日中午12 时至2024年2月18
        日上午8时平台系统维护，2024年2月18日8时后系统正常。 】
      </van-dialog>
    </div>

    <div class="phonelist_btn">
      <img src="../imgs/phone.gif" class="phonelist_bg" />
      <div class="phonelist_btn_text">各市、县（市、区）人社部门联系方式</div>
      <van-button
        color="#4967B7"
        class="phonelist_btn_to"
        type="info"
        plain
        size="small"
        @click="toPhoneList"
      >
        去查看
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      checked: false,
      radioValue: "1",
      show: false
    };
  },
  methods: {
    radioChange() {},
    toEngineer() {
      if (this.radioValue === "1") {
        this.$router.push({path: "/engineer", query: {...this.$route.query}});
      } else if (this.radioValue === "2") {
        this.$router.push({path: "/notEngineer", query: {...this.$route.query}});
      }
    },
    toPhoneList() {
      window.location = 'https://sd.shengbangtec.com/map/#/sd'
      // this.$router.push({path: "/phonelist", query: {...this.$route.query}});
    }
  },
  mounted() {
    if (+new Date() >= +new Date(2024, 1, 18)) {
      this.show = false;
    } else {
      this.show = true;
    }

  }
};
</script>

<style lang="less" scoped>
.Index {
  padding: 16px 24px;
  height: 60vh;
  position: relative;
  box-sizing: border-box;
  .title {
    font-size: 20px;
    color: #333;
  }
  .content {
    padding: 16px;
    .options {
      padding: 10px 0 20px;
      .van-radio {
        margin-bottom: 10px;
        :deep(.van-radio__label) {
          font-size: 14px;
        }
      }
    }
    .tips {
      color: #999;
      position: absolute;
      left: 26px;
      right: 26px;
      bottom: 25vh;
    }
    .agree {
      color: #4967b7;
      margin-top: 48px;
      position: absolute;
      left: 26px;
      right: 26px;
      bottom: 2vh;
      .van-checkbox {
        align-items: flex-start;
        :deep(.van-checkbox__icon) {
          margin-top: 3px;
        }
      }
      .btn {
        .van-button {
          width: 100%;
          margin-top: 12px;
        }
      }
    }
  }
}
.phonelist_btn {
  font-size: 15px;
  position: relative;
  display: flex;
  align-items: center;
  background-color: rgb(243, 247, 250);
  width: 96%;
  padding: 16px;
  box-sizing: border-box;
  margin: 8px auto;
  border-radius: 8px;
  img{
    width: 50px;
    height: 50px;
  }
  .phonelist_btn_text{
    flex-shrink: 1;
    padding: 0 16px;
    color: #888;
    width: 60%;
    line-height: 22px;
    font-size: 15px;
  }
  .phonelist_btn_to{
    flex-shrink: 0;
  }
}
</style>
<style lang="less"></style>
